import RequestService, {
    RequestServiceResponse,
} from '@tcc-online/request-service';
import { NotificationActions } from '../common/actions/NotificationActions';
import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';

const ENDPOINT = '/tickets';

const ContactService = {
    sendRequest,
};

type SendRequestPayload = {
    email: string;
    message: string;
};

async function sendRequest(
    payload: SendRequestPayload,
    api: GetThunkAPI<any>,
): Promise<RequestServiceResponse<any, { email: string; message: string }>> {
    const { email, message } = payload;
    const response = await RequestService.post(
        ENDPOINT,
        { email, message },
        { ignoreAuth: true },
    );
    api.dispatch(NotificationActions.success(response.data?.message));

    return response;
}

export default ContactService;
